var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNmbr6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 76,
    viewBox: "0 0 94 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 37.6914C88 55.0884 73.897 69.1914 56.5 69.1914C39.103 69.1914 25 55.0884 25 37.6914C25 20.2944 39.103 6.19141 56.5 6.19141C73.897 6.19141 88 20.2944 88 37.6914Z",
    fill: "white",
    stroke: "#2C4245",
    strokeWidth: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7176 33.6874C64.3656 30.3914 62.1256 27.3194 57.3576 27.3194C51.4376 27.3194 48.9736 31.5434 48.9736 39.1594C48.9736 46.3914 50.7016 51.2554 57.6136 51.2554C62.6056 51.2554 65.3896 47.9594 65.3896 43.4474C65.3896 38.5834 62.4776 35.8314 58.3176 35.8314C56.0456 35.8314 53.9336 36.7914 52.8776 38.5514C52.9416 33.1754 54.2856 30.9994 57.1976 30.9994C59.2136 30.9994 60.1416 31.9594 60.5576 33.6874H64.7176ZM57.2936 39.5114C59.8856 39.5114 61.1336 41.1434 61.1336 43.5434C61.1336 45.9434 59.6936 47.4474 57.3896 47.4474C54.7656 47.4474 53.2936 45.8794 53.2936 43.3834C53.2936 40.7274 55.2136 39.5114 57.2936 39.5114Z",
    fill: "#32474A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 39.9235C1.66667 39.1537 1.66667 37.2292 3 36.4594L22.5 25.201C23.8333 24.4312 25.5 25.3935 25.5 26.9331L25.5 49.4497C25.5 50.9893 23.8333 51.9516 22.5 51.1818L3 39.9235Z",
    fill: "#2C4245"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmbr6);
export default __webpack_public_path__ + "static/media/nmbr6.0d00f3c10b0c6c245aea94813dd16ee6.svg";
export { ForwardRef as ReactComponent };